export default "__VITE_ASSET__Crg0FRsH__"